import _styled from '@emotion/styled/base';
import { Spacing } from '@tablekit/theme';
import { getLoadingStyle } from './commonStyles.js';

function getMargin(_ref) {
  var hasIconAfter = _ref.hasIconAfter,
      hasIconBefore = _ref.hasIconBefore,
      isVertical = _ref.isVertical;
  var topMargin = isVertical ? Spacing.L3 : 0;
  var leftMargin = hasIconBefore && !isVertical ? Spacing.L2 : 0;
  var rightMargin = hasIconAfter ? Spacing.L2 : 0;
  return "".concat(topMargin, " ").concat(rightMargin, " 0 ").concat(leftMargin);
}

var ButtonContent = _styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1ie7bvs0"
} : {
  target: "e1ie7bvs0",
  label: "ButtonContent"
})("margin:", getMargin, ";max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:600;", getLoadingStyle, ";");

export { ButtonContent };
